"use client";
import WebLayout from "@/components/layout/web/WebLayout";
import CPageHeader from "@/components/main/CPageHeader";
import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const JobsLayout = ({ children, blogsPageData, dictionary }) => {
  const items = [
    { title: dictionary.home, href: "/" },
    { title: blogsPageData?.landing?.title },
  ];
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathName = usePathname();
  const [searchItems, setSearchItems] = useState({});

  useEffect(() => {
    let temp = {};

    for (let [key, value] of searchParams.entries()) {
      if (key == "tag") {
        value = searchParams.getAll("tag");
      }

      temp[key] = value;
    }
    setSearchItems(temp);
  }, [searchParams]);

  const onFilterApply = (values) => {
    router.push(
      `${pathName.split("/page")[0]}?${Object.entries(values)
        .filter((item) => item[1])
        .map((item) => {
          return Array.isArray(item[1])
            ? item[1]
              .map((item2) => `${item[0]}=${encodeURIComponent(item2)}&`)
              .join("")
            : `${item[0]}=${encodeURIComponent(item[1])}&`;
        })
        .join("")}`,
      { scroll: false }
    );
  };

  const onSearch = (text) => {
    onFilterApply({ ...searchItems, search: text });
  };

  return (
    <div>
      <CPageHeader
        title={blogsPageData?.landing?.title}
        links={items}
        subTitle={blogsPageData?.landing?.description}
        onSearch={onSearch}
        dictionary={dictionary}
      />
      {children}
    </div>
  );
};

export default WebLayout(JobsLayout);
